/*
 * OB TIE DYE — EVENT SOURCE LINKS
 * ------------------------------------------------------------
 * EASY EDIT: add or update links here.
 * Format: ['part of event title','https://source-url.com/']
 * This file attaches links to event data ONCE before the app renders.
 * ------------------------------------------------------------
 */
(function(){
  var LINKS=[
    ['trivia night at mike hess ocean beach','https://www.mikehessbrewing.com/ocean-beach/'],
    ['trivia at carruth cellars','https://carruthcellars.com/events/trivia-liberty/'],
    ['trivia at wonderland ocean pub','https://www.wonderlandob.com/menus/'],
    ['trivia at northside tavern','https://northsidetavernob.com/san-diego-ocean-beach-northside-tavern-events'],
    ['trivia at the loma club','https://www.thelomaclub.com/events-calendar'],
    ['trivia at pizza port ocean beach','https://www.pizzaport.com/events/trivia-night-at-pizza-port-ocean-beach/'],
    ['trivia at stone brewing kettner','https://www.stonebrewing.com/events/kettner-trivia-night-every-thursday'],
    ['trivia at california wild ales','https://californiawildales.com/trivia-two-locations-two-vibes/'],
    ['trivia at shakespeare pub','https://www.shakespearepub.com/quiz-nights'],
    ['trivia at dirty birds ocean beach','https://oceanbeachsandiego.com/resources/local-news/trivia-nights-dirty-birds-ob'],
    ['beer bingo at bottlecraft','https://bottlecraft.com/locations/liberty-station-beer-shop/'],
    ['karaoke at the cordova bar','https://www.thecordovabar.com/san-diego-events/'],
    ['electric waste band','https://winstonsob.com/calendar/week/electric-waste-band'],
    ['ob run club','https://www.runclubseverywhere.com/run-clubs/ocean-beach-run-club'],
    ['stone liberty station run club','https://www.stonebrewing.com/events/stone-run-club-every-wednesday'],
    ['eppig waterfront run club','https://www.eppigbrewing.com/events/pointlomaevents'],
    ['donation yoga at sunset cliffs','https://www.yogajawn.com/sunset-cliffs-yoga'],
    ['oceanfront yoga','https://namasteve-yoga.com/'],
    ['ob farmers market','https://oceanbeachsandiego.com/attractions/annual-events/farmers-market-wednesdays'],
    ['wednesday night art market','https://kilowatt.beer/events/'],
    ['little italy mercato','https://www.littleitalysd.com/do/little-italy-mercato'],
    ['pacific beach farmers market','https://www.sandiego.org/things-to-do/shopping/farmers-markets'],
    ['point loma farmers market','https://www.sandiego.org/things-to-do/shopping/farmers-markets'],
    ['gaslamp artisan market','https://gaslamp.org/news/gaslamp-artisan-market/'],
    ['hillcrest farmers market','https://hillcrestfarmersmarket.com/'],
    ['new point loma farmers market','https://www.sandiego.org/things-to-do/shopping/farmers-markets'],
    ['pb shore club','https://www.pbshoreclub.com/'],
    ['alfred robles','https://americancomedyco.com/collections/alfred-robles-live-september-17-19'],
    ['greg fitzsimmons','https://www.thecomedystore.com/comedians/greg-fitzsimmons'],
    ['sam morril','https://americancomedyco.com/products/sam-morril-live-thu'],
    ['ryan sickler','https://www.thecomedystore.com/comedians/ryan-sickler'],
    ['annie lederman','https://thecomedystore.com/comedians/annie-lederman/'],
    ['jeff garlin','https://thecomedystore.com/comedians/jeff-garlin'],
    ['rocky dale davis','https://americancomedyco.com/collections/rocky-dale-davis'],
    ['michael yo','https://www.michaelyo.com/'],
    ['black uhuru','https://bellyup.com/calendar/14811453/black-uhuru-kat-hall/'],
    ['falcon 9 starlink launch viewing','https://www.spacex.com/launches/sl-15-27'],
    ['falcon 9 launch viewing','https://www.spacex.com/launches/ussf259'],
    ['inna vision + jordan t','https://theholdingcompanyob.com/show/inna-vision-jordan-t/'],
    ['marlins at padres','https://www.mlb.com/padres/tickets'],
    ['sugaray rayford','https://www.humphreysbackstagelive.com/event/sugaray-rayford-w-michele-lundeen/'],
    ['capital of craft beer festival','https://www.sdbeer.com/'],
    ['adams avenue street fair','https://www.adamsavenuebusiness.com/adams-avenue-street-fair/'],
    ['surf lounge festival','https://www.kpbs.org/events/2026/09/19/surf-lounge-festival'],
    ['safety orange + gun shy + tropical drip','https://theholdingcompanyob.com/show/safety-orange-3/'],
    ['birding walk at famosa slough','https://secure.sandiegobirdalliance.org/np/clients/sandiegobirdalliance/eventList.jsp'],
    ['the temptations & the four tops','https://www.ticketmaster.com/artist/956755'],
    ['san diego restaurant week','https://www.sandiegorestaurantweek.com/'],
    ['mcas miramar air show','https://miramarairshow.com/'],
    ['pacific islander festival','https://www.pifasandiego.com/events/festival'],
    ['encinitas oktoberfest','https://www.encinitasoktoberfest.com/'],
    ['la mesa oktoberfest','https://www.lamesaoktoberfest.org/'],
    ['pacific beachfest','https://www.pacificbeachfest.org/'],
    ['ob oktoberfest','https://www.oboktoberfest.com/'],
    ['la jolla art & wine festival','https://www.ljawf.com/'],
    ['san diego international film festival','https://sdfilmfest.com/festival-schedule/'],
    ['mission bayfest','https://www.bayfestsd.com/'],
    ['full harvest moon','https://www.timeanddate.com/moon/phases/usa/san-diego'],
    ['saturn at opposition','https://in-the-sky.org/news.php?id=20261004_12_100'],
    ['draconid meteor shower','https://www.timeanddate.com/astronomy/meteor-shower/draconid.html'],
    ['orionid meteor shower','https://science.nasa.gov/solar-system/meteors-meteorites/orionids/'],
    ['san diego made holiday market','https://www.sdmademarkets.com/holiday-2026-info'],
    ['mariachi usa','https://www.theshell.org/performances/mariachi-usa-2026/'],
    ['temples','https://wl.seetickets.us/event/temples-poppy-jean-crawford/687287?afflky=Casbah'],
    ['dana and alden','https://wl.seetickets.us/event/dana-and-alden-ania-hoo/693572?afflky=Casbah'],
    ['a.j. croce','https://www.humphreysconcerts.com/schedule.cfm?RECID=695'],
    ['detroit underground','https://www.humphreysbackstagelive.com/event/detroit-underground-39/2026-09-26/'],
    ['hot wheels monster trucks','https://hotwheelsmonstertruckslive.com/event/san-diego-ca-2026/'],
    ['balthvs','https://theholdingcompanyob.com/show/balthvs/'],
    ['nahko and medicine for the people','https://theholdingcompanyob.com/show/nahko-and-medicine-for-the-people-hoka-10th-anniversary-tour/'],
    ['keller williams','https://theholdingcompanyob.com/show/keller-williams-3/'],
    ['smooth operator','https://www.axs.com/events/1455998/smooth-operator-sade-tribute-tickets'],
    ['collective soul','https://www.ticketmaster.com/event/0A0064AB27E9F814'],
    ['air supply','https://www.livenation.com/event/vvG1IZ_A6glcWK/air-supply-a-matter-of-time-tour'],
    ['aj lee & blue summit','https://www.eventim.com/event/aj-lee-blue-summit-casbah-21860268/'],
    ['muna','https://www.livenation.com/event/vvG1IZ_18W2pnn/muna-gets-so-hot-tour'],
    ['tinlicker','https://www.livenation.com/event/vvG1IZ_adhnyQI/tinlicker-north-america-2026'],
    ['10,000 maniacs','https://www.ticketmaster.com/10000-maniacs-san-diego-california-10-17-2026/event/0A006462F8029CAC'],
    ['moe.','https://venues.bellyup.com/calendar/14940093/moe-an-evening-with'],
    ['madeon','https://www.livenation.com/event/vvG1IZ_185x9WF/madeon-presents-victory-live'],
    ['america','https://www.ticketmaster.com/america-the-happy-trails-tour-san-diego-10-24-2026/event/0A006451FB55E3F7'],
    ['city of the sun','https://wl.eventim.us/event/city-of-the-sun/698722?afflky=Casbah'],
    ['gary clark jr.','https://www.ticketmaster.com/gary-clark-jr-tickets/artist/1583670'],
    ['empire of the sun + polo & pan','https://www.mlb.com/padres/tickets/concerts'],
    ['keznamdi','https://winstonsob.com/calendar/month/2026-10'],
    ['maka roots','https://theholdingcompanyob.com/shows/'],
    ['birdstock','https://birdstockmusicfestival.com/'],
    ['san diego bayfair','https://sandiegobayfair.org/'],
    ['craftober fest','https://dosd.com/events/2026/9/18/craftober-fest-tickets']
  ];

  function norm(s){return String(s||'').toLowerCase().replace(/[’‘]/g,"'").replace(/\s+/g,' ').trim();}
  function linkFor(title){var t=norm(title);for(var i=0;i<LINKS.length;i++)if(t.indexOf(LINKS[i][0])!==-1)return LINKS[i][1];return '';}
  function patchItems(){(window.OB_GUIDE_ITEMS||[]).forEach(function(item){var u=linkFor(item.title);if(u)item.url=u;});}

  patchItems();
  window.OB_GUIDE_EVENT_LINKS={linkFor:linkFor,patchItems:patchItems};
})();

/* OB GUIDE SHAREABLE FILTER URLS */
(function(){
  'use strict';
  var applying=false,bound=false;
  function slug(s){return String(s||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'')}
  function optionFor(select,key){
    key=String(key||'').toLowerCase();
    for(var i=0;i<select.options.length;i++)if(slug(select.options[i].value)===key)return select.options[i].value;
    return'';
  }
  function inferredRegion(hoodKey){
    var items=window.OB_GUIDE_ITEMS||[];
    for(var i=0;i<items.length;i++){
      var hood=items[i]&&(items[i].hood||items[i].neighborhood);
      if(slug(hood)===hoodKey)return items[i].region||'';
    }
    return'';
  }
  function hoodMulti(){return document.querySelector('.og-multi[data-key="regionhoods"]')}
  function syncUrl(){
    if(applying||!window.history||!history.replaceState)return;
    var rs=document.getElementById('regionSelect'),multi=hoodMulti();
    if(!rs||!multi)return;
    try{
      var u=new URL(location.href),p=u.searchParams,region=rs.value;
      p.delete('area');
      if(!region||region==='all'){
        p.delete('region');p.delete('neighborhood');
      }else{
        var checks=Array.prototype.slice.call(multi.querySelectorAll('input[type="checkbox"]'));
        var checked=checks.filter(function(cb){return cb.checked});
        var all=checks.length>0&&checked.length===checks.length;
        if(region==='San Diego'&&all){
          p.delete('region');p.delete('neighborhood');
        }else{
          p.set('region',slug(region));
          if(!checked.length)p.set('neighborhood','none');
          else if(all)p.delete('neighborhood');
          else p.set('neighborhood',checked.map(function(cb){return slug(cb.value)}).join(','));
        }
      }
      history.replaceState({},'',u.pathname+(p.toString()?'?'+p.toString():'')+u.hash);
    }catch(e){}
  }
  function applyFromUrl(){
    var rs=document.getElementById('regionSelect'),multi=hoodMulti();
    if(!rs||!multi)return;
    var p;
    try{p=new URL(location.href).searchParams}catch(e){return}
    var regionKey=p.get('region')||'',hoodRaw=p.get('neighborhood')||'',legacyArea=p.get('area')||'';
    if(!regionKey&&legacyArea){
      var legacyRegion=optionFor(rs,slug(legacyArea));
      if(legacyRegion)regionKey=slug(legacyRegion);
      else{
        var inferred=inferredRegion(slug(legacyArea));
        if(inferred){regionKey=slug(inferred);hoodRaw=slug(legacyArea)}
      }
    }
    if(!regionKey&&hoodRaw&&hoodRaw!=='none'){
      var first=hoodRaw.split(',')[0],fromHood=inferredRegion(first);
      if(fromHood)regionKey=slug(fromHood);
    }
    var regionValue=optionFor(rs,regionKey);
    if(!regionValue){syncUrl();return}
    applying=true;
    rs.value=regionValue;
    rs.dispatchEvent(new Event('change',{bubbles:true}));
    multi=hoodMulti();
    if(multi&&hoodRaw){
      var clear=multi.querySelector('[data-action="none"]');
      if(clear)clear.click();
      if(hoodRaw!=='none'){
        var wanted=hoodRaw.split(',').map(function(v){return v.trim().toLowerCase()}).filter(Boolean);
        var checks=Array.prototype.slice.call(multi.querySelectorAll('input[type="checkbox"]'));
        checks.forEach(function(cb){if(wanted.indexOf(slug(cb.value))!==-1&&!cb.checked)cb.click()});
      }
    }
    applying=false;
    syncUrl();
  }
  function bind(){
    if(bound)return;bound=true;
    document.addEventListener('change',function(e){
      if(applying)return;
      if(e.target&&e.target.id==='regionSelect')setTimeout(syncUrl,0);
      else if(e.target&&e.target.matches&&e.target.matches('.og-multi[data-key="regionhoods"] input[type="checkbox"]'))setTimeout(syncUrl,0);
    },true);
    document.addEventListener('click',function(e){
      if(applying)return;
      var a=e.target&&e.target.closest&&e.target.closest('.og-multi[data-key="regionhoods"] [data-action]');
      if(a)setTimeout(syncUrl,0);
    },true);
  }
  function waitForFilters(tries){
    var rs=document.getElementById('regionSelect'),multi=hoodMulti();
    if(rs&&rs.options&&rs.options.length>1&&multi){bind();applyFromUrl();return}
    if(tries<80)setTimeout(function(){waitForFilters(tries+1)},50);
  }
  setTimeout(function(){waitForFilters(0)},0);
})();
